<template>
  <div class="min-w-64">
    <label class="text-sm font-semibold mb-1 dark:text-white">
      <slot name="label">Label</slot>
    </label>
    <div class="flex items-center gap-2">
      <u-range
        v-model="dataModel"
        :min="min"
        :max="max"
        :step="step"
        @mousedown="onDragStart"
        @mouseup="onDragEnd"
      />
      <u-input
        :model-value="dataModel"
        @update:modelValue="updateNumberInput"
        type="number"
        :min="min"
        :max="max"
        :step="step"
        :ui="{
          rounded: 'rounded-md',
          base: `text-center w-[50px] [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none`
        }"
      />
    </div>
  </div>
</template>

<script setup>

  const emit = defineEmits(['commitUpdates', 'dragStart', 'dragEnd']);
  const props = defineProps({
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    }
  });

  const dataModel = defineModel();

  function updateNumberInput(newVal) {
    dataModel.value = newVal;
    commitUpdates();
  }

  function onDragStart() {
    emit('dragStart');
  }

  function onDragEnd() {
    emit('dragEnd');
    emit('commitUpdates');
  }

  function commitUpdates() {
    emit('commitUpdates');
  }

</script>
